import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

import { SolidWarnButton } from 'components/buttons/SolidWarnButton';
import { OutlineButton } from 'components/buttons/OutlineButton';
import ModalContainer from 'components/ModalContainer';

const RemoveCaptivePortalModal = ({ openRemoveModal, closeRemoveModal, clickRemoveBtn, isSelectedCount, showEditGeneral }) => {
  const theme = useTheme();

  return (
    <>
      <ModalContainer display={openRemoveModal} modalWidth="500px">
        <Box sx={{ padding: '0 10px', textAlign: 'center' }}>
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              overflowWrap: 'anywhere',
              marginBottom: 1,
            }}
          >
            Remove Captive Portal
          </Typography>

          <Box
            sx={{
              display: 'flex',
              paddingTop: '10px',
              paddingBottom: '20px',
              justifyContent: 'center',
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[2],
            }}
          >
            <Typography>Are you sure you want to remove </Typography>
            <Typography
              sx={{
                fontWeight: theme.typography.customFontWeight[1],
                paddingLeft: 1,
                paddingRight: 1,
              }}
            >
              {isSelectedCount}
            </Typography>
            <Typography> profile(s)?</Typography>
          </Box>

          <Box
            sx={{
              paddingTop: '20px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <OutlineButton sx={{ marginRight: '20px' }} width="100px" height="32px" onClick={closeRemoveModal}>
              Cancel
            </OutlineButton>
            <SolidWarnButton width="100px" height="32px" onClick={clickRemoveBtn} disabled={!showEditGeneral}>
              Remove
            </SolidWarnButton>
          </Box>
        </Box>
      </ModalContainer>
    </>
  );
};

export default RemoveCaptivePortalModal;
